<template>
    <v-container fluid>
        <v-row v-if="showPdfPreview">
            <div
                style="
                    display: show;
                    z-index: 9999999;
                    position: fixed;
                    top: 0px;
                    left: 0px;
                    background-color: rgba(255, 255, 255, 0.074);
                    width: 100%;
                    height: 100vw;
                "
            >
                <div style="margin-top: 20px; margin-bottom: 40px; width: 40%; height: 100vh; margin: 0 auto">
                    <v-btn
                        style="float: right; margin-top: 50px; margin-bottom: 10px"
                        depressed
                        @click="closePDFpreview()"
                        icon
                    >
                        <v-icon large>fas fa-window-close</v-icon>
                    </v-btn>
                    <iframe
                        id="pdf-preview-div"
                        style="width: 100%; margin-bottom: 20px; height: 87vh; display: block"
                        :src="pdfLink"
                    >
                        <p>Your browser does not support iframes.</p>
                    </iframe>
                </div>
            </div>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ salaryLabel }}
                        <v-tooltip bottom>
                            <template v-slot:activator="{on, attrs}">
                                <v-btn icon v-bind="attrs" @click="seeMore = !seeMore" v-on="on">
                                    <v-icon small>fas fa-caret-down</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('tooltips.seeMore') }}</span>
                        </v-tooltip>
                    </v-card-title>
                    <v-card-text>
                        <v-row v-if="seeMore == true">
                            <v-col cols="8">
                                <v-data-table
                                    :headers="objectHeaders"
                                    :items="objectList"
                                    fixed-header
                                    dense
                                    class="row-item"
                                    :items-per-page="-1"
                                    :hide-default-footer="true"
                                    :height="200"
                                    :no-data-text="$t('labels.noData')"
                                >
                                    <template v-slot:item="row">
                                        <tr :class="{'cursor-pointer': true}">
                                            <td>
                                                {{ row.item.day_type }}
                                            </td>
                                            <td>
                                                {{ row.item.date_from_display }}
                                            </td>
                                            <td>
                                                {{ row.item.date_to_display }}
                                            </td>
                                            <td>
                                                {{ row.item.total_days }}
                                            </td>
                                            <td>
                                                {{ row.item.day_rate }}
                                            </td>
                                            <td>
                                                {{ row.item.contract_id }}
                                            </td>
                                            <td>
                                                {{ row.item.total_amount }}
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-col>
                            <v-col cols="4">
                                <v-row>
                                    <v-col
                                        cols="12"
                                        v-if="timesheet.timesheet_status_id == 4 || timesheet.timesheet_status_id == 5"
                                    >
                                        <Dropdown
                                            key="ts-status-full"
                                            :readonly="
                                                timesheet.timesheet_status_id == 5 ||
                                                timesheet.timesheet_status_id == 4 ||
                                                (timesheet.timesheet_status_id != 5 &&
                                                    timesheet.timesheet_status_id != 4 &&
                                                    !inEditMode)
                                            "
                                            v-model="timesheet.timesheet_status_id"
                                            :ajax="true"
                                            :data="'expense-statuses'"
                                            :label="$t('fields.status')"
                                            @input="changeStatus()"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col cols="12" v-else>
                                        <Dropdown
                                            key="ts-status-edit"
                                            :readonly="
                                                timesheet.timesheet_status_id == 5 ||
                                                timesheet.timesheet_status_id == 4 ||
                                                (timesheet.timesheet_status_id != 5 &&
                                                    timesheet.timesheet_status_id != 4 &&
                                                    !inEditMode)
                                            "
                                            v-model="timesheet.timesheet_status_id"
                                            :ajax="true"
                                            :data="'expense-statuses-edit'"
                                            :label="$t('fields.status')"
                                            @input="changeStatus()"
                                        ></Dropdown>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        v-if="
                                            (timesheet.timesheet_status_id == 5 ||
                                                timesheet.timesheet_status_id == 4) &&
                                            this.inEditMode
                                        "
                                        class="text-center"
                                    >
                                        <v-btn
                                            v-if="$myStore.state.user.user_role_id == 1"
                                            class="ml-2 mr-2"
                                            color="secondary"
                                            @click="updateTimesheet()"
                                        >
                                            <v-icon small>fas fa-sync</v-icon>&nbsp;{{ $t('buttons.updateTimesheet') }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="text-center"> {{ userLabel }}</v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <Upload
                                            :readonly="
                                                timesheet.timesheet_status_id == 5 ||
                                                timesheet.timesheet_status_id == 4 ||
                                                (timesheet.timesheet_status_id != 5 &&
                                                    timesheet.timesheet_status_id != 4 &&
                                                    !inEditMode)
                                            "
                                            v-model="timesheet.uploaded_file"
                                            :view="true"
                                            @input="checkUpload"
                                            @viewclick="viewPdf"
                                        ></Upload>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Dropdown from './trinkets/Dropdown';
import Upload from './trinkets/Upload.vue';
import Timesheet from '../models/Timesheet';
export default {
    name: 'PlacementSalaryTable',
    components: {
        Dropdown,
        Upload,
    },
    props: ['salary', 'reload', 'inEditMode'],
    data: function () {
        return {
            objectList: [],
            objectHeaders: [
                {text: this.$t('fields.dayType'), sortable: false},
                {text: this.$t('fields.startDate'), sortable: false},
                {text: this.$t('fields.endDate'), sortable: false},
                {text: this.$t('fields.days'), sortable: false},
                {text: this.$t('fields.dayRate'), sortable: false},
                {text: this.$t('fields.contractId'), sortable: false},
                {text: this.$t('fields.totalAmount'), sortable: false},
            ],
            seeMore: true,
            salaryLabel: '',
            salaryEditing: false,
            timesheet: new Timesheet({}),
            userLabel: '',
            showPdfPreview: false,
            pdfSource: '',
        };
    },

    watch: {
        reload: {
            handler: function () {
                if (this.reload == 'salary') {
                    this.reloadData();
                }
            },
            deep: true,
        },
    },
    methods: {
        checkUpload() {
            let vm = this;
            var ext = this.timesheet.uploaded_file.original_name.split('.').pop();
            if (ext == 'pdf' || ext == 'PDF' || ext == '') {
                let document = this.timesheet.uploaded_file;
                let user = this.$myStore.state.user.id;
                this.$APICall('post', 'timesheet-document/' + this.timesheet.id, {document, user}, (data, succes) => {
                    if (!succes) {
                        vm.$alert(vm.$t('alerts.basicError'));
                    } else {
                        vm.reloadData();
                    }
                });
            } else {
                this.timesheet.uploaded_file.name = '';
                this.timesheet.uploaded_file.link = '';
                this.timesheet.uploaded_file.original_name = '';
                this.timesheet.uploaded_file.upload_id = null;
                this.$alert(this.$t('alerts.onlyPdf'));
            }
        },
        updateTimesheet() {
            this.$verify(this.$t('alerts.updateTimesheetQuestion'), (result) => {
                if (result) {
                    let vm = this;
                    let salary = this.salary;
                    this.$APICall(
                        'put',
                        'salary/' + this.salary.id,
                        {salary},
                        (data, success) => {
                            if (success) {
                                vm.objectList = [];
                                vm.objectList = data.items;
                                vm.salaryLabel = data.label;
                                vm.timesheet = data.timesheet;
                                vm.userLabel = data.user_label;
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                        false,
                    );
                }
            });
        },
        closePDFpreview() {
            this.showPdfPreview = false;
            this.pdfLink = '';
        },
        viewPdf() {
            this.showPdfPreview = true;
            this.pdfLink = this.timesheet.uploaded_file.public_link;
        },
        changeStatus() {
            let vm = this;
            let status = this.timesheet.timesheet_status_id;
            let user = this.$myStore.state.user.id;
            this.$APICall('post', 'change-timesheet-status/' + this.timesheet.id, {status, user}, (data, succes) => {
                if (!succes) {
                    vm.$alert(vm.$t('alerts.basicError'));
                } else {
                    vm.reloadData();
                }
            });
        },
        salaryEdit() {
            this.salaryEditing = true;
        },
        reloadData() {
            let vm = this;
            this.$APICall(
                'get',
                'salary/' + this.salary.id,
                {},
                (data, success) => {
                    if (success) {
                        vm.objectList = data.items;
                        vm.salaryLabel = data.label;
                        vm.timesheet = data.timesheet;
                        vm.userLabel = data.user_label;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        this.reloadData();
    },
};
</script>
